import React from 'react';
import { formatConsignmentStockValue } from '../../utils/consignment.util';

/**
 * Normalise les consignements d'une étape (nouveau format ou legacy nb_pallets_*).
 */
export function getStepConsignments(step) {
  const consignments = step?.additional_datas?.consignments;
  if (Array.isArray(consignments) && consignments.length > 0) {
    return consignments;
  }

  const left = step?.additional_datas?.nb_pallets_left;
  const retaked = step?.additional_datas?.nb_pallets_retaked;
  if (left || retaked) {
    return [
      {
        packaging_code: 'PALETTE',
        packaging_label: 'Palette',
        nb_left: left || 0,
        nb_retaked: retaked || 0,
      },
    ];
  }

  return [];
}

export function hasStepConsignments(step) {
  return getStepConsignments(step).length > 0;
}

export default function StepConsignmentsDisplay({ step }) {
  const consignments = getStepConsignments(step);

  if (!consignments.length) {
    return null;
  }

  return (
    <div className="tw-flex tw-flex-col tw-pl-[50px] tw-items-start tw-justify-start tw-w-full tw-gap-1">
      <div className="tw-relative tw-tracking-[-0.02em] tw-font-medium tw-mb-1">
        Palettes consignées
      </div>
      {consignments.map((entry, index) => {
        const label =
          entry.packaging_label ||
          entry.label ||
          entry.packaging_code ||
          `Type ${index + 1}`;

        return (
          <div
            key={`${entry.packaging_code}-${index}`}
            className="tw-flex tw-flex-col tw-text-[13px] tw-font-work tw-text-[rgba(0,0,0,0.75)]"
          >
            <span className="tw-font-medium tw-text-[rgba(0,0,0,0.90)]">
              {label}
              {entry.packaging_code && entry.packaging_label && (
                <span className="tw-font-normal tw-text-[rgba(0,0,0,0.45)] tw-ml-1">
                  ({entry.packaging_code})
                </span>
              )}
            </span>
            <span>
              Laissées : {formatConsignmentStockValue(entry.nb_left ?? 0)} —
              Reprises : {formatConsignmentStockValue(entry.nb_retaked ?? 0)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
